import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import T from '../../i18n/T'
import { TAG_SEARCH_GEOLOCATION } from '../../../store/analytics/analytics.actionTypes'
import { setGeolocationStatus } from '../../../store/map/map.actions'
import {
  GEOLOC_STATUS_BLOCKED,
  GEOLOC_STATUS_BUTTON_WORKFLOW,
  GEOLOC_STATUS_DISABLED,
  GEOLOC_STATUS_FETCH_ACTIVE,
  GEOLOC_STATUS_FETCH_FOLLOW,
  GEOLOC_STATUS_FOLLOW
} from '../../../store/map/map.constants'
import { selectGeolocationStatus } from '../../../store/map/map.selectors'
import { selectShouldDisplayMapTools } from '../../../store/ui/ui.selectors'
import TagActionButton from '../../genericComponents/TagActionButton'
import SVGIcon from '../../svg/SVGIcon'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import useTimeout from '../../utils/useTimeout'
import s from './GeolocButton.less'
import useTooltip from './useTooltip'

const GeolocButton = () => {
  const status = useSelector(selectGeolocationStatus)
  const [statusFromButton, setStatusFromButton] = useState(null)
  const execSetGeolocationStatus = useAction(setGeolocationStatus)
  const [displayError, setDisplayError] = useState(false)
  const [setErrorTo, clearErrorTo] = useTimeout(5000)
  const isFollowStatus = status === GEOLOC_STATUS_FOLLOW
  const isFetchStatus = status === GEOLOC_STATUS_FETCH_ACTIVE || status === GEOLOC_STATUS_FETCH_FOLLOW
  const { tooltip, mouseListeners } = useTooltip()

  useEffect(() => {
    if (statusFromButton) {
      if (status === GEOLOC_STATUS_BLOCKED) {
        setDisplayError(true)
        setErrorTo(() => setDisplayError(false))
      }
      if (status !== statusFromButton) {
        setStatusFromButton(null)
      }
    }
  }, [setErrorTo, status, statusFromButton])

  useEffect(() => {
    return () => {
      clearErrorTo()
    }
  }, [clearErrorTo])

  const onClick = () => {
    const newStatus = GEOLOC_STATUS_BUTTON_WORKFLOW[status]
    if (newStatus !== GEOLOC_STATUS_DISABLED) {
      setStatusFromButton(newStatus)
      execSetGeolocationStatus(newStatus, { mapMove: true })
    } else {
      execSetGeolocationStatus(newStatus)
    }
  }

  return (
    <>
      <TagActionButton type={TAG_SEARCH_GEOLOCATION} className={s.geoloc} onClick={onClick} deferClick  {...mouseListeners}>
        <div className={classNames(s.button, isFollowStatus ? s.follow : s.active)}>
          <div className={classNames('icon', s.icon)}>
            <div className={classNames(s.icon, isFetchStatus && s.fetch)}>
              <SVGIcon icon={'geolocation'} />
            </div>
          </div>
        </div>
        <span className={classNames(s.tooltip, tooltip && 'active')}>
          <T id={'map.tools.geoloc.tooltip'} />
        </span>
      </TagActionButton>
      {displayError && (
        <div className={s.errorMessage}>
          {`Votre position est bloquée, vous devez l'autoriser sur votre navigateur.`}
        </div>
      )}
    </>
  )
}

export default withEverySelectorTruthy(selectShouldDisplayMapTools())(GeolocButton)
